export enum PolicyTerms {
  QL_ORV_2020_01 = 'QL_ORV_2020_01',
  QL_GG_2020_06 = 'QL_GG_2020_06',
}
